import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import * as DateHelper from '@/Utility/DateHelper';

/**
 * Das ViewModel für den Calendar
 */
export default class CalendarViewModel extends ControlViewModel {
    private LinkViewModel = ComponentManager.getViewModel('LinkViewModel');

    /**
     * Der DateTime-String vom .NET
     */
    public value: KnockoutObservable<string>;

    /**
     * Ein Placeholder falls das Control keine Eingabe enthält
     */
    public placeholder: KnockoutComputed<string>;

    /**
     * Das minimal auswählbare Datum im Calendar
     */
    public min: KnockoutObservable<Date>;

    /**
     * Das maximal auswählbare Datum im Calendar
     */
    public max: KnockoutObservable<Date>;

    /**
     * Das Date-Objekt
     */
    public date: KnockoutComputed<Date>;

    /**
     * Das Date-Objekt als String im Format der aktuellen Sprache
     */
    public dateString: KnockoutComputed<string>;

    /**
     * Das ViewModel für den Calendar
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.value = this.observableOrDefault(params.value, '');
        this.placeholder = this.defineComputed(() => {
            let language = ResourceManager.getInstance().getLanguage();
            let placeholder = language.datePattern;

            return placeholder;
        });
        this.min = this.observableOrDefault(params.min, new Date(1900, 0, 1));
        this.max = this.observableOrDefault(params.max, new Date(2099, 11, 31));
        this.date = this.definePureComputed({
                read: () => {
                    let value = this.value();
                    let date = DateHelper.parseDotNetDateTimeString(value);

                    return date;
                },
                write: (date: Date) => {
                    let value = DateHelper.toDotNetDateString(date);
                    this.value(value);
                }
            });
        this.dateString = this.defineComputed(() => {
            let date = this.date();
            let value = DateHelper.toString(date);

            return value;
        });
    }

    public resetValue(): void {
        this.value(null);
    }
}

ComponentManager.setViewModel('CalendarViewModel', CalendarViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');